export const APIUrl = import.meta.env.VITE_API_URL || 'https://app.talentsense.ai';
export const logosURL = import.meta.env.VITE_LOGOS_URL || 'https://talentsense.ai/logos/';

// Which Jacques capacity chart to render: 'legacy' (canvas + PNG), 'visx' (new
// vector chart) or 'both' (side by side, for comparison). Build-time flag via
// VITE_JACQUES_CHART_MODE; defaults to 'visx'.
export const jacquesChartMode = import.meta.env.VITE_JACQUES_CHART_MODE || 'visx';
export const showLegacyJacquesChart = jacquesChartMode !== 'visx';
export const showVisxJacquesChart = jacquesChartMode !== 'legacy';